export const noFooterList = [
  "/sw",
  "/bd",
  "/baidu",
  "/tieba",
  "/bdAboutUs",
  "/bdproductInfo",
  "/bdpermit",
  "/bdsoftwareLis",
  "/bdprivacy",
  "/360m",
  "/jiayinwangyixinwen",
  "/jiayinwangyiyunyinyue",
  "/jyaiqiyi",
  "/dxaiqiyi",
  "/wangyiyixiao",
  "/kuaishou",
  "/360m/001",
  "/msougou",
  "/m996",
  "/msougou1",
  "/wm",
  "/zdzm",
  "/uc2",
  "/uc3",
  "/uc4",
  "/msougou2",
  "/uc",
  "/gt",
  "/wb/996",
  "/ibaidu",
  "/ibaidu2",
  "/sougou2",
  "/sougou3",
  "/yx3605",
  "/sigmob1"
];
